import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Check: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'check'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M9.99999 15.172L19.192 5.979L20.607 7.393L9.99999 18L3.63599 11.636L5.04999 10.222L9.99999 15.172Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Check
